import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Tere ON24 tiim,
Leidsin sama toote mujalt soodsama hinnaga.
Siit leidsin selle toote soodsamalt \(sisesta link\): ...
Seal on hind \(sisesta hind\): ...
 
ON24’s on antud toode: <span style="color:#a6d189;">**{product_url}**</span>
Tavahind: <span style="color:#a6d189;">**{price}**</span>
Kliendikontohind: <span style="color:#a6d189;">**{customer_price}**</span>
Soodushind: <span style="color:#a6d189;">**{discount_price}**</span>
 
Jään teie pakkumist ootama!
Tervitades,

  <span style="color:#85c1dc;">**FI:**</span>
  Hei ON24 tiimi,
Löysin saman tuotteen muualta edullisemmalla hinnalla.

Löysin tämän tuotteen edullisemmin täältä \(lisää linkki\): …
Siellä hinta oli \(lisää hinta\): …

ON24:ssa tämä tuote on: <span style="color:#a6d189;">**{product_url}**</span>
Normaalihinta: <span style="color:#a6d189;">**{price}**</span>
Asiakastilihinta: <span style="color:#a6d189;">**{customer_price}**</span>
Alennushinta: <span style="color:#a6d189;">**{discount_price}**</span>

Jään odottamaan tarjoustanne!
Terveisin

  <span style="color:#85c1dc;">**RU:**</span>
  Здравствуйте, сотрудники ON24!
Я нашёл тот же товар в другом месте по более низкой цене.
Здесь я нашёл этот товар дешевле \(вставьте ссылку\): …
Там цена была \(вставьте цену\): …

В ON24 данный товар: <span style="color:#a6d189;">**{product_url}**</span>
Обычная цена: <span style="color:#a6d189;">**{price}**</span>
Цена по клиентскому счёту: <span style="color:#a6d189;">**{customer_price}**</span>
Цена со скидкой: <span style="color:#a6d189;">**{discount_price}**</span>

Жду вашего предложения!
С уважением,
*/
/* @__NO_SIDE_EFFECTS__ */
const m1281 = msg(
  mf`Tere ON24 tiim,
Leidsin sama toote mujalt soodsama hinnaga.
Siit leidsin selle toote soodsamalt (sisesta link): ...
Seal on hind (sisesta hind): ...
 
ON24’s on antud toode: ${'product_url'}
Tavahind: ${'price'}
Kliendikontohind: ${'customer_price'}
Soodushind: ${'discount_price'}
 
Jään teie pakkumist ootama!
Tervitades,`,
  mf`Hei ON24 tiimi,
Löysin saman tuotteen muualta edullisemmalla hinnalla.

Löysin tämän tuotteen edullisemmin täältä (lisää linkki): …
Siellä hinta oli (lisää hinta): …

ON24:ssa tämä tuote on: ${'product_url'}
Normaalihinta: ${'price'}
Asiakastilihinta: ${'customer_price'}
Alennushinta: ${'discount_price'}

Jään odottamaan tarjoustanne!
Terveisin`,
  mf`Здравствуйте, сотрудники ON24!
Я нашёл тот же товар в другом месте по более низкой цене.
Здесь я нашёл этот товар дешевле (вставьте ссылку): …
Там цена была (вставьте цену): …

В ON24 данный товар: ${'product_url'}
Обычная цена: ${'price'}
Цена по клиентскому счёту: ${'customer_price'}
Цена со скидкой: ${'discount_price'}

Жду вашего предложения!
С уважением,`,
)

export { m1281 as 'w.module.product.ask_price.mail.body' }